import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { TERMS } from 'src/app/app-routing.module';
import { LEADSIGNUP } from '../../authentication-lead.module';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { Router } from '@angular/router';

@Component({
    selector: 'fp-lead-login',
    templateUrl: './lead-login.component.html',
    styleUrl: './lead-login.component.scss',
    standalone: false
})
export class LeadLoginComponent implements OnInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    public authService: AuthenticationService,
    private notificationService: NotificationService,
    private navigation: NavigationService,
    public translate: TranslateService,
    private errorHandler: ErrorHandlerService,
    private router: Router
  ) {
    this.pendingError = history.state?.snackbarError?.error;
  }
  pendingError: string | null = null;
  loginForm: UntypedFormGroup;
  resetPasswordForm: UntypedFormGroup;
  createAccountForm: UntypedFormGroup;
  invalidLogin = false;
  authPage = 'login';
  message: string;
  errorMessage: boolean;
  email: string = '';
  TERMS = TERMS;
  LEADSIGNUP = LEADSIGNUP;

  async ngOnInit() {
    this.loginForm = this.formBuilder.group({
      login: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
    this.resetPasswordForm = this.formBuilder.group({
      email: [null, [Validators.required]],
    });
    const user = await this.authService.getMe();
    if (user) {
      await this.navigation.processLogin(user.role);
    }

    if (this.pendingError) {
      history.replaceState({}, '');
      this.notificationService.openSnackBar('error', this.errorHandler.translateError(this.pendingError));
      this.pendingError = null;
    }
  }

  public onType() {
    if (this.loginForm.get('password').value !== '') {
      this.invalidLogin = false;
    }
  }

  async login() {
    if (this.loginForm.valid) {
      const username = this.loginForm.get('login').value;
      const password = this.loginForm.get('password').value;
      const user = await this.authService.logIn(username, password);
      if (user) {
        await this.navigation.processLogin(user.role);
      } else {
        this.invalidLogin = true;
        this.loginForm.reset();
        const el = document.getElementById('login');
        el.focus();
        this.notificationService.openSnackBar('error', this.translate.instant('AUTH.INCORRECT_USERNAME_OR_PASSWORD'));
      }
    }
  }

  resetPassword() {
    if (this.resetPasswordForm.valid) {
      this.notificationService.loading = true;
      this.email = this.resetPasswordForm.get('email').value;
      this.authService.resetPassword(this.email).subscribe({
        next: res => {
          this.errorMessage = false;
          this.message = 'AUTH.RESET_PASSWORD.MESSAGE';
          this.notificationService.loading = false;
          this.resetPasswordForm.reset();
        },
        error: err => {
          if (err.status == 400) {
            this.message = this.errorHandler.translateError(err.error);
            this.errorMessage = true;
            this.notificationService.loading = false;
          } else {
            this.errorMessage = false;
            this.message = 'AUTH.RESET_PASSWORD.MESSAGE';
            this.notificationService.loading = false;
            this.resetPasswordForm.reset();
          }
        },
      });
    }
  }
}
